import React from "react";
import { useTranslation } from "react-i18next";
import NavBar from "../features/components/nav/Nav";
import Bg from "../features/assets/bg-2.jpeg";
import Slider from "./components/slider/Slider";
import CookieConsent from "react-cookie-consent";

const Home = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        backgroundImage: `url(${Bg})`,
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
      }}
    >
      <NavBar />
      <Slider />
      <CookieConsent
        location="bottom"
        cookieName="myAwesomeCookieName3"
        expires={999}
        overlay
      >
        {t("cookie_message")}
      </CookieConsent>
    </div>
  );
};

export default Home;
